import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import { Layout } from '../components/common'
import { MetaData } from '../components/common/meta'
import { LayoutMeta } from '../components/common/meta'
/**
 * Single post view (/:slug)
 *
 * This file renders a single post and loads all the content dghgd.
 *

 */

export function Head({ data, location }) {
  const post = data.ghostPost
  return (
    <>
      <MetaData data={data} location={location} type="article" />
      <LayoutMeta />
      <meta name="robots" content="noindex, nofollow" />
      <style type="text/css">{`${post.codeinjection_styles}`}</style>
    </>
  )
}

const Article = ({ data, location }) => {
  const post = data.ghostPost

  return (
    <>
      <Layout>
        <section className="bannerAreaN BannerDeatils mb-5 article-hero">
          <div className="detailsPageSection articlebanner">
            <img
              src="https://res.cloudinary.com/vantagecircle/image/upload/v1709807887/VantageFit/2023/background-new.webp"
              alt="corporate wellness"
              className="img-responsive"
              width="1435"
              height="500"
            />
          </div>
          <div className="BannerContent article-title pt-4">
            <div className="headingBannerM container customCampaignContainer text-left ">
              <div className="row">
                <div className="text-center col-lg-12 col-xs-12 col-md-12 col-sm-12 detailbanner">
                  {/* <img width="220" height="45" className="mb-5 site-logo" src="https://res.cloudinary.com/vantagecircle/image/upload/w_220/VantageFit/website/01-vantagefit-logo-2_compress.png" alt="Vantage Fit- A Global Employee Wellness Platform for Corporates"/> */}
                  <div className="successstory">Articles</div>
                  <h1 className="colorwhite">{post.title}</h1>
                  <p className="colorwhite mx-auto hero-para font-weight-semibold no-br">{post.excerpt}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <article className="content content-inner vfit-articles">
          {/* The main post content */}
          <div className="container customCampaignContainer ">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 single-post-image feat-article-img">
                <img
                  src={post.feature_image}
                  alt={post.title}
                  className="mx-auto inner-featured-image lozad img-responsive"
                  width="800"
                  height="449"
                  loading="lazy"
                />
              </div>
              <div
                className="col-lg-12 content-body load-external-scripts editor-content"
                dangerouslySetInnerHTML={{ __html: post.html }}
              />
            </div>
          </div>
        </article>
      </Layout>
    </>
  )
}

Article.propTypes = {
  data: PropTypes.shape({
    ghostPost: PropTypes.shape({
      codeinjection_styles: PropTypes.object,
      title: PropTypes.string.isRequired,
      html: PropTypes.string.isRequired,
      feature_image: PropTypes.string,
    }).isRequired,
  }).isRequired,
  location: PropTypes.object.isRequired,
}

export default Article

export const post1Query = graphql`
  query ($slug: String!, $language: String!) {
    ghostPost(slug: { eq: $slug }) {
      ...GhostPostFields
    }
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    allGhostPost(
      filter: { tags: { elemMatch: { name: { eq: "#article" } } }, slug: { ne: $slug } }
      sort: { published_at: DESC }
      limit: 3
    ) {
      edges {
        node {
          ...GhostPostFields
        }
      }
    }
  }
`
